import * as React from 'react';

import { Bone } from '@lightspeed/flame/Bone';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Heading4 } from '@lightspeed/flame/Text';

import { useNuorderOrdering } from 'root/apps/PurchaseOrder/NuorderOrdering/context/Context';
import { NuorderBrandAddress } from 'root/apps/PurchaseOrder/NuorderOrdering/types';
import { getLocale } from 'root/apps/PurchaseOrder/NuorderOrdering/utils/dataUtils';

export const SummaryInfo = () => {
  const {
    state: { purchase, vendorShop, nuorderBrand },
  } = useNuorderOrdering();

  const address = React.useMemo(() => {
    if (!vendorShop) return 'n/a';
    if (!nuorderBrand) return 'n/a';
    const allAddresses = nuorderBrand.companies.flatMap<NuorderBrandAddress>(
      (company) => company.addresses
    );
    const address = allAddresses.find((address) => address.id === vendorShop.b2bShippingAddressUID);
    if (!address) return 'n/a';
    return [
      address.line_1,
      address.line_2,
      address.city,
      address.state,
      address.zip,
      address.country,
    ]
      .filter((val) => val && val.trim())
      .join(', ');
  }, [vendorShop, nuorderBrand]);

  const date = React.useMemo(() => {
    if (!purchase) return 'n/a';
    if (!purchase.arrivalDate) return 'n/a';
    return purchase.arrivalDate.toLocaleDateString(getLocale(), {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }, [purchase]);

  const note = React.useMemo(() => {
    return purchase?.Note?.note || 'n/a';
  }, [purchase]);

  if (!purchase) {
    return (
      <Box flexBasis="66%" data-test="summary-info-bones">
        <Bone width={200} height={20} style={{ marginBottom: '1em' }} />
        <Bone width={200} height={20} style={{ marginBottom: '1em' }} />
      </Box>
    );
  }

  return (
    <Box flexBasis="66%" data-test="summary-info">
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Box mr={1} flexBasis="50%" flexShrink={0}>
          <Heading4>Ship to</Heading4>
          <p data-test="summary-info-address">
            <var>{address}</var>
          </p>
        </Box>
        <Box ml={1}>
          <Heading4>Expected delivery</Heading4>
          <p data-test="summary-info-date">
            <var>{date}</var>
          </p>
        </Box>
      </Flex>
      <Box mt={2}>
        <Heading4>General Notes</Heading4>
        <p data-test="summary-info-note">
          <var>{note}</var>
        </p>
      </Box>
    </Box>
  );
};
